export default {
  state: {
    queryString: '',
    strings: [],
    dbStrings: [],
    loadedStrings: [],
    showSearchField: false,
    searchFormField: {}
  },

  mutations: {
    searchLocaleString: (state, queryString) => {
      queryString = queryString.toLowerCase();
      for (let i = 0; i <= state.loadedStrings.length - 1; i++) {
        for (let j = 0; j <= state.loadedStrings[i].form.length - 1; j++) {
          var tempArr = [];
          tempArr.push(state.loadedStrings[i].form[j]);
          state.searchFormField = tempArr.find(x => x.displayName.toLowerCase() == queryString);
          if (state.searchFormField && state.searchFormField.hasOwnProperty('key')) {
            state.showSearchField = true;
            return
          }
        }
      }
      state.showSearchField = false;
      state.searchFormField = {};
      console.log("There is no result found. Refine your search string");
    }
  },
  actions: {
    searchLocaleString: (context, payload) => {
      context.commit('searchLocaleString', payload)
    }
  }
}